<template>
  <div>
    <footer style="padding: 10px;">
      <div class="container">
        <span class="gotop">
          <a href="javascript:void(0);" @click="goTop" id="GoTop" title="맨위로이동"></a>
        </span>
      </div>
      <div class="adress">
       <div class="container">
	      <span class="txt">SK스피드메이트(주) 경기도 수원시 장안구 경수대로976번길 19(송죽동)</span>
	        <span class="txt bl_ico">대표이사 이환용  <span class="ml10">사업자 등록번호 788-87-03184</span> <span class="ml10">전화 1588-4087</span>
	        </span>
          <span>
            <a class="button dark" style="cursor:pointer; margin: 0 0 0 0;" @click="openCoursePopup"><span>개인 정보 처리 방침</span></a>
          </span>
	        <p class="copyright">Copyright ⓒ 2024 by SK speedmate Co., Ltd. All Rights Reserved</p>
	    </div>
	  </div>
    <CoursePopup ref="coursePopup" class="popup" style="display:none" />
    </footer>
  </div>
</template>

<script>
import {TweenMax} from "gsap/TweenMax";
import commons from '@/assets/js/commons';
import CoursePopup from '@/views/CoursePopup.vue';

export default {
  name: 'footerView',
  components: {
    CoursePopup
  },
  methods : {
    goTop () {
      TweenMax.to($('body, html'), 0.5, {scrollTop:0, ease:"Cubic.easeOut"});
    },
    openCoursePopup() {
      let routeData1 = this.$router.resolve({name : 'CoursePopup', params:{}});
		  this.openPopup(routeData1, 'coursePopup', 1000, 800, 'Y', 800);
    },
    openPopup (obj, popName, width, height, scrollYn, addX, addY) {
      var popupX = (window.screen.width / 2) - (width / 2) + (addX ? addX : 0);
      var popupY = ((window.screen.height / 2) - (height / 2)) - 50 + (addY ? addY : 0);

      var options = 'status=no, width='+ width +', height='+ height +', left='+ popupX + ', top='+ popupY;

      if ( scrollYn == 'Y' ) {
        options += ', scrollbars=yes';
      } else {
        options += ', scrollbars=auto';
      }

      window.open(obj.href, popName, options);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FooterView.vue